import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core';
import { styles } from "./style";

const NoPropView = ({ classes, message, image }) => {
  return (
    <Box className={classes.root}>
      <Box className={classes.emptyBox}>
        <img src={image || "/prop@2x.png"} alt="No Properties" />
        <Typography className={classes.NPText}>
          {message}
        </Typography>
      </Box>
    </Box>
  )
}

export default withStyles(styles)(NoPropView)